import { NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  GrooveActionDirective,
  GroovePullquoteDirective,
} from '@groove/angular';
import { FUNNEL_QUOTES } from '../../../../content/funnel-trust/funnel-quotes';
import { FunnelTrustComponent } from '../../../../content/funnel-trust/funnel-trust.component';
import { YoutubeSectionComponent } from '../../../../content/youtube-section/youtube-section.component';
import { DATA_CONFIG } from '../../../../injection-tokens';
import { SEOService } from '../../../../seo.service';
import { buildWhatITeachPageSchemas } from './what-i-teach-jsonld';

@Component({
  selector: 'app-what-i-teach-content',
  imports: [
    NgOptimizedImage,
    FunnelTrustComponent,
    RouterLink,
    GroovePullquoteDirective,
    GrooveActionDirective,
    YoutubeSectionComponent,
  ],
  templateUrl: './what-i-teach-content.component.html',
  styleUrl: './what-i-teach-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhatITeachContentComponent implements OnDestroy {
  private readonly dataConfig = inject(DATA_CONFIG);
  private seo = inject(SEOService);
  protected readonly funnelQuote = FUNNEL_QUOTES.whatITeach;
  protected readonly playlistUrl = this.dataConfig.youtubeLessonsPlaylist;

  constructor() {
    // No route param to react to, so a plain constructor call is enough —
    // this page's JSON-LD never changes after mount. Sets the VideoObject +
    // ItemList schemas that used to live in app.routes.ts's static
    // data.seo.jsonLd; see what-i-teach-jsonld.ts for why this moved.
    this.seo.setRouteSchemas(buildWhatITeachPageSchemas());
  }

  ngOnDestroy(): void {
    this.seo.clearRouteSchemas();
  }
}
